@if (resolvedTitle(); as titleText) {
    <sirius-heading
        class="feature-explorer-title"
        [text]="titleText"
        textStyleCategory="title"
        textStyleSize="xl"
        [h]="2"
    />
}

<div class="feature-explorer-columns">
    <div #stage class="feature-explorer-stage" [style.aspect-ratio]="resolvedAspect()">
        @if (resolvedImage(); as stageImage) {
            <sirius-image-item
                [image]="stageImage"
                [imageData]="stageImageData"
                objectFit="contain"
                [autocrop]="false"
            />
        }
        @if (markers().length) {
            <div
                class="feature-explorer-markers"
                role="group"
                [attr.aria-label]="'productFeatureExplorer.featureLocations' | translate"
            >
                @for (marker of markers(); track marker.number; let markerIndex = $index) {
                    <button
                        #markerButton
                        type="button"
                        class="feature-explorer-marker sir-text-style-paragraph-m-bold"
                        [class.is-active]="active() === marker.number"
                        [style.--feature-explorer-marker-index]="markerIndex"
                        [style.left.%]="marker.hotspot.x"
                        [style.top.%]="marker.hotspot.y"
                        [attr.aria-label]="marker.markerLabel"
                        [attr.aria-expanded]="active() === marker.number"
                        [attr.aria-controls]="marker.regionId"
                        [tabindex]="markerIndex === markerTabStop() ? 0 : -1"
                        (focus)="markerTabStop.set(markerIndex)"
                        (keydown)="onMarkerKeydown($event, markerIndex)"
                        (click)="toggleFromMarker(marker)"
                    >
                        {{ marker.number }}
                    </button>
                }
            </div>
        }
    </div>

    @for (column of columns(); track $index; let leading = $first) {
        <div class="feature-explorer-column" [class.is-trailing]="!leading">
            @for (panel of column; track panel.number) {
                <ng-template #trigger>
                    <span
                        class="feature-explorer-marker sir-text-style-paragraph-m-bold"
                        [class.is-active]="active() === panel.number"
                        >{{ panel.number }}</span
                    >
                    <span class="feature-explorer-label">
                        <span class="feature-explorer-panel-title sir-text-style-paragraph-m-bold">{{
                            panel.title
                        }}</span>
                        @if (panel.teaser) {
                            <span class="feature-explorer-teaser sir-text-style-paragraph-s-default">{{
                                panel.teaser
                            }}</span>
                        }
                    </span>
                </ng-template>

                <sirius-disclosure
                    #featurePanel
                    class="feature-explorer-panel"
                    [triggerContent]="trigger"
                    [headingLevel]="3"
                    [regionId]="panel.regionId"
                    [expanded]="active() === panel.number"
                    (expandedChange)="setOpen(panel, $event)"
                >
                    @if (panel.detailsHtml) {
                        <sirius-text-html [html]="panel.detailsHtml" textStyleSize="s" />
                    }
                </sirius-disclosure>
            }
        </div>
    }
</div>
